import type { TBboxStyleAttrs } from './types';

export const DEFAULT_STYLES: TBboxStyleAttrs = {
  base: { stroke: 'rgba(34, 196, 93, 1)', strokeWidth: 2 },
  hover: { stroke: 'rgba(34, 196, 93, 1)', strokeWidth: 3 },
  selected: { stroke: 'rgba(34, 196, 93, 1)', strokeWidth: 3, fill: 'rgba(34, 196, 93, 0.2)' },
};
